<template>
  <div class="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 text-center">
    <div class="text-primary font-bold" style="font-size: clamp(6rem, 20vw, 9.375rem); line-height: 1">
      {{ error.statusCode }}
    </div>
    <h1 class="mt-8 text-2xl font-semibold tracking-tight text-foreground">
      {{ getTitle() }}
    </h1>
    <div class="mt-3 mb-8 text-muted-foreground">
      {{ getDescription() }}
    </div>
    <Button type="button" @click="handleError">
      На главную
    </Button>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import { Button } from '~/components/ui/button';

const props = defineProps({
  error: Object as () => NuxtError
});

function getTitle(): string {
  if (props.error === undefined || props.error.statusMessage === undefined || props.error.statusMessage === null || props.error.statusMessage === '') {
    return 'Что-то пошло не так';
  }

  if (props.error.statusCode === 404) {
    return 'К сожалению, страница не найдена';
  }

  return props.error.statusMessage;
}
function getDescription(): string {
  return 'Нам очень жаль за предоставленные неудобства.';
}
function handleError() {
  clearError({
    redirect: '/',
  });
}
</script>
